// extracted by mini-css-extract-plugin
module.exports = {"BC_container":"Banner-module__BC_container","brdCrmb":"Banner-module__brdCrmb"};